const SEED_PHOTOS = [
  {
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=1000&auto=format&fit=crop',
    caption: 'Campus Main Auditorium & Convocation Hall',
    uploadedAt: '2026-08-15',
    fileSize: '480 KB',
  },
  {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?q=80&w=1000&auto=format&fit=crop',
    caption: 'University Administration & Central Library',
    uploadedAt: '2026-08-16',
    fileSize: '520 KB',
  },
  {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?q=80&w=1000&auto=format&fit=crop',
    caption: 'Advanced Physics & Chemistry Research Laboratory',
    uploadedAt: '2026-08-17',
    fileSize: '610 KB',
  },
  {
    id: 4,
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1000&auto=format&fit=crop',
    caption: 'Interactive Smart Classroom Lecture Session',
    uploadedAt: '2026-08-18',
    fileSize: '430 KB',
  },
  {
    id: 5,
    imageUrl: 'https://images.unsplash.com/photo-1577495508048-b635879837f1?q=80&w=1000&auto=format&fit=crop',
    caption: 'Inter-College Sports Tournament & Athletic Ground',
    uploadedAt: '2026-08-19',
    fileSize: '590 KB',
  },
  {
    id: 6,
    imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1000&auto=format&fit=crop',
    caption: 'Student Career Mentorship & Tech Symposium',
    uploadedAt: '2026-08-19',
    fileSize: '510 KB',
  },
]

function getStoredPhotos() {
  try {
    const raw = localStorage.getItem('cloud_gallery_photos')
    if (!raw) {
      localStorage.setItem('cloud_gallery_photos', JSON.stringify(SEED_PHOTOS))
      return SEED_PHOTOS
    }
    return JSON.parse(raw)
  } catch {
    return SEED_PHOTOS
  }
}

function saveStoredPhotos(list) {
  try {
    localStorage.setItem('cloud_gallery_photos', JSON.stringify(list))
    window.dispatchEvent(new Event('cloud-gallery-updated'))
  } catch (err) {
    console.error('Failed to save gallery photos to localStorage', err)
  }
}

export async function fetchGalleryPhotos() {
  await new Promise((resolve) => setTimeout(resolve, 80))
  const list = getStoredPhotos()
  return {
    photos: list,
    totalCount: list.length,
  }
}

export async function uploadPhoto({ imageUrl, caption = '' }) {
  await new Promise((resolve) => setTimeout(resolve, 150))
  const list = getStoredPhotos()

  const newPhoto = {
    id: Date.now() + Math.floor(Math.random() * 1000),
    imageUrl: imageUrl || 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=1000&auto=format&fit=crop',
    caption: caption.trim() || 'Campus Gallery Picture',
    uploadedAt: new Date().toISOString().split('T')[0],
    fileSize: '450 KB',
  }

  const updatedList = [newPhoto, ...list]
  saveStoredPhotos(updatedList)
  return newPhoto
}

export async function deletePhoto(id) {
  await new Promise((resolve) => setTimeout(resolve, 80))
  const list = getStoredPhotos()
  const targetId = parseInt(id, 10)
  const filtered = list.filter((p) => p.id !== targetId)
  saveStoredPhotos(filtered)
  return { success: true }
}
